"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNewsArticles = void 0;
exports.defaultNewsArticles = {
    items: [{
            id: 770,
            content: '14 September 2018 - OKAY.com’s Consultant Matthieu Ober was featured on iCable’s Hong Kong property program “Property Outlook” (「樓盤傳真」) on 8 September 2018, where he showcased a recently sold apartment in Goa Building, Sai Ying Pun. This property was originally purchased in 2010 for HK$2.9M. The original landlord held the property for 8 years, duri',
            title: 'OKAY.com Consultant Matthieu Ober Promotes Goa Building on iCable',
            url: 'https://dev.okay.com/property-news/OKAYcom-Consultant-Matthieu-Ober-Promotes-Goa-Building-on-iCable/770?nid=65',
            altText: 'OKAY.com Consultant Matthieu Ober Promotes Goa Building on iCable - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/0_636725193166981783.jpg',
            authors: [{
                    name: 'Matthieu Ober',
                    url: 'https://devnew.okay.com/real-estate-agents/matthieu-ober/514?ppid=1&pno=1',
                    id: 514,
                }],
        },
        {
            id: 767,
            content: '12 September 2018 - OKAY.com’s Director (Residential Division) Andrea Adams Ott was featured on iCable’s Hong Kong property program “Property Outlook” (「樓盤傳真」) on 8 September 2018, where she showcased an apartment in Village Terrace 27-29, Happy Valley.',
            title: 'OKAY.com Director Andrea Adams Ott Promotes Village Terrace 27-29 on iCable',
            url: 'https://dev.okay.com/property-news/OKAYcom-Director-Andrea-Adams-Ott-Promotes-Village-Terrace-27-29-on-iCable/767?nid=65',
            altText: 'OKAY.com Director Andrea Adams Ott Promotes Village Terrace 27-29 on iCable - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/767_636723674013381531.jpg',
            authors: [{
                    name: 'Andrea Adams Ott',
                    url: 'https://devnew.okay.com/real-estate-agents/andrea-adams-ott/321?ppid=1&pno=1',
                    id: 321,
                }],
        },
        {
            id: 765,
            content: '11 September 2018 - One of Hong Kong’s largest property agencies recently stated that out of the 160,000 second-hand property listings online, only about 10,000 are “real” i.e. actually on the market for sale or lease.  This PR announcement also declared that they plan to eliminate thousands of fake listings on their website and although it’s uncle',
            title: 'In the News: Are Property Agencies Finally Shaping Up?',
            url: 'https://dev.okay.com/property-news/In-the-News-Are-Property-Agencies-Finally-Shaping-Up/765?nid=65',
            altText: 'In the News: Are Property Agencies Finally Shaping Up? - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/0_636722749032844889.jpg',
            authors: [{
                    name: 'Joshua Han Miller',
                    url: 'https://dev.okay.com/property-experts/joshua-han-miller/362',
                    id: 362,
                }],
        },
        {
            id: 761,
            content: '23 August 2018 - OKAY.com’s Director (Residential Division) Belinda Woo was featured on iCable’s Hong Kong property program “Property Outlook” (「樓盤傳真」) on 18 August 2018, where she showcased an apartment in Villas Sorrento, Pokfulam.\r\n\t\t\t\r\n\t\t\t\t \r\n\t\t\t\r\n\t\t\t\tThe advertised 3 bed/3 bath unit is well-located along Mt Davis Road, with stunning sea and gr',
            title: 'OKAY.com Director Belinda Woo Promotes Villas Sorrento on iCable',
            url: 'https://dev.okay.com/property-news/OKAYcom-Director-Belinda-Woo-Promotes-Villas-Sorrento-on-iCable/761?nid=65',
            altText: 'OKAY.com Director Belinda Woo Promotes Villas Sorrento on iCable - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/0_636710509113299300.jpg',
            authors: [{
                    name: 'Belinda M L Woo',
                    url: 'https://devnew.okay.com/real-estate-agents/belinda-m-l-woo/244?ppid=1&pno=1',
                    id: 244,
                }],
        },
        {
            id: 755,
            content: '13 August 2018 - Whether you’re talking price-per-square-foot or affordability, Hong Kong is known as one of the most expensive housing markets worldwide. According to a recent report by the UBS Global Real Estate Bubble Index, you’ll need 20 years of income to purchase a home in Hong Kong—compared to 16 years in London, and 11 years in Singapore a',
            title: 'Why is Hong Kong Housing so Expensive?',
            url: 'https://dev.okay.com/property-news/Why-is-Hong-Kong-Housing-so-Expensive/755?nid=65',
            altText: 'Why is Hong Kong Housing so Expensive? - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/755_636697685563008252.jpg',
            authors: [{
                    name: 'Joshua Han Miller',
                    url: 'https://dev.okay.com/property-experts/joshua-han-miller/362',
                    id: 362,
                }],
        },
        {
            id: 751,
            content: '8 August 2018 - OKAY.com property agent Ruby Suen appears on Property Outlook on iCable sharing the points to note when buying an apartment through company share transfer.\r\n\t\r\n\t\t \r\n\t\r\n\t\t1.       Check for hidden liabilities or litigation\r\n\t\r\n\t\t2.       Overseas registered companies must be handled by international law firms\r\n\t\r\n\t\t3.       The regis',
            title: 'OKAY.com Property Agent Ruby Suen Appears on iCable',
            url: 'https://dev.okay.com/property-news/OKAYcom-Property-Agent-Ruby-Suen-Appears-on-iCable/751?nid=65',
            altText: 'OKAY.com Property Agent Ruby Suen Appears on iCable - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/0_636693446959808861.jpg',
            authors: [{
                    name: 'Ruby T Y Suen',
                    url: 'https://devnew.okay.com/real-estate-agents/ruby-t-y-suen/243?ppid=1&pno=1',
                    id: 243,
                }],
        },
        {
            id: 749,
            content: "13 July 2018 - OKAY.com property CEO Joshua Han Miller appears on ViuTVsix News at prime time for his views on Carrie Lam's latest property comments.",
            title: 'OKAY.com Property CEO Joshua Han Miller Appears on ViuTVsix',
            url: 'https://dev.okay.com/property-news/OKAYcom-Property-CEO-Joshua-Han-Miller-Appears-on-ViuTVsix/749?nid=65',
            altText: 'OKAY.com Property CEO Joshua Han Miller Appears on ViuTVsix - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/0_636670894307534820.jpg',
            authors: [{
                    name: 'Joshua Han Miller',
                    url: 'https://dev.okay.com/property-experts/joshua-han-miller/362',
                    id: 362,
                }],
        },
        {
            id: 746,
            content: "10 July 2018 - OKAY.com CEO Joshua Han Miller shares with 932 Magazine how the company's technology and its game-changing internal platform TITAN have sharped the industry.\r\n\r\n\tClick here to read the full article (only available in Chinese).",
            title: 'OKAY.com Featured in 932 Magazine',
            url: 'https://dev.okay.com/property-news/OKAYcom-Featured-in-932-Magazine/746?nid=65',
            altText: 'OKAY.com Featured in 932 Magazine - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/746_636669069777314202.jpg',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: null,
                }],
        },
        {
            id: 745,
            content: '6 July 2018 - OKAY.com CEO Joshua Miller discusses what the new vacancy tax could mean for developers and consumers.\r\n\r\n\t \r\n\r\n\tThe Vacancy Tax - Structure\r\n\r\n\t \r\n\r\n\tOn June 30th, the government announced its new policy imposing a vacancy tax on developers regarding unsold first-hand private residential flats, constituting a tax amounting to 2 years',
            title: 'Hong Kong’s New Vacancy Tax – Overview and Interpretation',
            url: 'https://dev.okay.com/property-news/Hong-Kongs-New-Vacancy-Tax--Overview-and-Interpretation/745?nid=65',
            altText: 'Hong Kong’s New Vacancy Tax – Overview and Interpretation - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/745_636664881884397316.jpg',
            authors: [{
                    name: 'Joshua Han Miller',
                    url: 'https://dev.okay.com/property-experts/joshua-han-miller/362',
                    id: 362,
                }],
        },
        {
            id: 739,
            content: "8 June 2018 - In an interview with China Daily, OKAY.com CEO Joshua Han Miller explains how the company's technology, coupled with its information-sharing and incentive-based culture, has given it a competitive edge. To further remedy the local imbalance in supply and demand, he also reveals OKAY.com's plans to focus more on developing advanced ana",
            title: 'China Daily Dubs OKAY.com the "Uber of Real Estate"',
            url: 'https://dev.okay.com/property-news/China-Daily-OKAY-Uber/739?nid=65',
            altText: 'China Daily Dubs OKAY.com the "Uber of Real Estate" - Hong Kong Property Market News & Insights',
            imageUrl: 'https://images.okay.com/ContentThumbnail/Original/739_636658701809641335.png',
            authors: [{
                    name: 'OKAY.com',
                    url: null,
                    id: null,
                }],
        }],
    pager: {
        totalItems: 316,
        currentPage: 1,
        pageSize: 10,
        totalPages: 32,
        startPage: 1,
        endPage: 10,
        hasPreviousPage: false,
        hasNextPage: true,
    },
    translate: {
        by: 'By',
        first: 'First',
        last: 'Last',
        next: 'Next',
        previous: 'Previous',
    },
};
